import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const container = document.getElementById('root') as HTMLElement;
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Prerendered pages (see scripts/prerender.js) ship with real markup already
// inside #root — hydrate onto it instead of a fresh render, so visitors
// don't see a flash where the static content gets discarded and rebuilt.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
